import { Component } from "react";
import DataLabel from "../DataLabel";
import { getDictItemList } from "../../service/dict";

import "./index.less";

export default class DictLabel extends Component {

  onLoad = () => {
    const { dict: dictCode, } = this.props;
    return getDictItemList({ dictCode, }).then(items => {
      let dictMap = {};
      items.forEach(item => {
        dictMap[item.value] = item;
      });
      return dictMap;
    });
  };

  render() {
    return (
      <DataLabel
        {...this.props}
        onLoad={this.onLoad}
      />
    );
  }
};
